/**
 * Vue router navigation guards with Vuex
 * Blocking off certain features of the application if the user is not authenticated
 */
/* e3slint-disable */
import store from '@/store/index';
import { usePrivilegesStore } from '@/stores/privileges';
import { PRIVILEGES } from '@/constants/privileges';

// Map ?dest= query values from notification emails to app routes.
// notes -> patient NotesPage; professional-notes -> ProfessionalNotesPage.
function resolveDestPath(dest) {
  if (!dest) return null;
  const d = String(dest);
  if (d === "/" || d === "") return "/welcome";
  if (d === "notes") return "/notes";
  if (d === "professional-notes") return "/professional-notes";
  if (d.startsWith("/")) return d;
  return null;
}


/*export function checkLoginStatus(to, from, next) {
  // console.log(to, from)
  const auth = useAuthStore()
  console.log("Authstore init");
  console.log(auth);
  console.log("PINA INSIDE OF VUEX STORE");
  console.log(auth.$state.isLoggedIn);
  console.log(auth.$state.is2faVerified);
  let isLoggedIn = store.getters['login/isLoggedIn'];
  console.log("Router guard: isLoggedIn =", isLoggedIn);
  //if is loggedIn, now check if 2factor is ture
  
  const hasResetParams = !!(to.query && to.query.email && to.query.token);
  const wantsReset = hasResetParams && (to.query.reset === '1' || to.path === '/' || to.path === '/login');
  if (wantsReset && !auth.isLoggedIn) {
    next({ path: '/reset', query: { email: to.query.email, token: to.query.token } });
    return;
  }
  if (to.path === '/'){
    if (isLoggedIn && auth.$state.is2faVerified)
      next('/welcome')
    else
      next('/login')
    return
  }
  if(to.path ==='/welcome' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified)
  {
    next('/login');
  }
  if(to.path ==='/medication' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified)
  {
    next('/login');
  }

  if (to.path === '/welcome' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/patientNurse' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/medAdministration' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/sixDigitAuthorization' &&  from.path === '/login' && !isLoggedIn){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/sixDigitAuthorization' && from.path === '/login' && (isLoggedIn && !auth.$state.is2faVerified)){
    document.title = 'PACMNY -Six Digit'
    next()
    return
  }
  if (to.path === '/medAdministration' && (from.path === '/' || from.path ==='/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/currentNurse' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/currentNurse' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/vitals' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/vitals' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/administration' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/administration' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/pdfs' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/pdfs' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/patients' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/patients' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/myOrg' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/myOrg' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/user/profile' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/user/profile' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/user/devices' && from.path === '/sixDigitAuthorization' && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.path === '/user/devices' && (from.path === '/' || from.path === '/login') && !auth.$state.is2faVerified){
    document.title = 'PACMNY - Login'
    next('/login')
    return
  }
  if (to.name === 'PrivacyPolicyNavigation' || to.name === 'TermsConditionsNavigation' || to.name === 'InformationProtectionNavigation'){
    next()
    return
  }
  if (to.query.dest === 'notes'){
    document.title = 'PACMNY - Notes'
    next('/notes')
    return
  }
  if (to.path === '/welcome' && from.path === '/login' && from.query.dest == 'notes'){
    document.title = 'PACMNY - Notes'
    next('/notes')
    return
  }
  if (to.path === '/login') {
    if (isLoggedIn && auth.$state.is2faVerified) 
      next('/welcome');
    else if (from.path == '/notes') {
      to.query.dest = 'notes'
      next()
    }
    else {
      next();
    }
  }
  else if (to.fullPath === '/null' && isLoggedIn){
    next('/welcome')
  }
  else if (to.path === '/register' 
  || to.path === '/forgot' 
  || to.path === '/reset'
  || to.path === '/verify'
  || to.path === '/verifyAccount'
  || to.name === 'VerifyNurseNavigation'
  || to.name === 'VerifyAccountNavigation'
  || to.name === 'VerifyContactNavigation'
  ) {
    if (isLoggedIn)
      next('/welcome');
    else next();
    return;
  }
  else {
    next();
  }
}*/ 

/// Public paths that do not require login/2FA
const PUBLIC_PATHS = [
  '/login',
  '/org-selection',
  '/register',
  '/adminregister',
  '/forgot',
  '/reset',
  '/sixDigitAuthorization',   // <-- ensure six-digit is allowed
  '/privacy-policy',
  '/terms',
  '/protection',
  // Account verification/registration pages (invite links with query params).
  '/verifyProvider',
  '/verifyAccount',
  '/verifyContact',
  '/verifyNurse',
];
 
// Routes allowed even if 2FA isn't completed because they rely on query params
const ALLOWED_QUERY_ROUTES = new Set([
  '/reset',
  '/forgot',
  '/register',
  '/verify',
  '/verifyAccount',
  '/verifyProvider', // med-order provider invite
  '/verifyContact',
  '/verifyNurse',
  '/notes'
]);
 
function isAllowedQueryRoute(to) {
  if (!to || !to.path) return false;
  if (ALLOWED_QUERY_ROUTES.has(to.path)) return true;
  const allowedNames = ['VerifyNurseNavigation', 'VerifyAccountNavigation', 'VerifyProviderNavigation', 'VerifyContactNavigation'];
  return allowedNames.includes(to.name);
}

/**
 * Redundant privilege check on /directives — defence in depth, not the
 * boundary. The pages themselves fail closed (they resolve read scope before
 * fetching anything); this only stops an obvious no-privilege navigation
 * earlier.
 *
 * Deliberately fails OPEN when privileges are not loaded yet. Navigation is
 * synchronous and the store populates asynchronously after login, so blocking
 * on "not loaded" would bounce legitimate users out of a cold-loaded deep
 * link. Failing closed belongs in the component, which can await the load;
 * failing closed here would be a worse regression than the redundancy is worth.
 */
function isBlockedDirectivesRoute(to) {
  if (!to || !to.path || !to.path.startsWith('/directives')) return false;
  // /directive-reauth-rules is a different feature with its own privilege.
  if (!(to.path === '/directives' || to.path.startsWith('/directives/'))) return false;
  try {
    // usePrivilegesStore() is only CALLED here, never at module scope — pinia
    // is installed after the router in main.js, but by navigation time it is
    // active. The try/catch covers the case where it somehow is not.
    const privileges = usePrivilegesStore();
    if (!privileges.loadedKey || !privileges.assignments.length) return false;
    return !privileges.effectiveGranted(PRIVILEGES.DIRECTIVE_READ);
  } catch (e) {
    return false;
  }
}
 
export function checkLoginStatus(to, from, next) {
  // read the module state directly (no getters were defined for these)
  const isLoggedIn = store.getters['login/isLoggedIn'];
  const is2faVerified = store.state.login?.is2faVerified === true;

  // `/` is the LoadingPage shell used during FSM bootstrap — not a real destination.
  if (to.path === '/' && isLoggedIn && is2faVerified) {
    return next('/welcome');
  }

  // Logged-in users should not remain on /login (e.g. after server session resume in a new tab).
  if (to.path === '/login' && isLoggedIn) {
    const intended = resolveDestPath(to.query.dest) || '/welcome';
    if (is2faVerified) return next(intended);
    store.commit('login/SET_INTENDED_ROUTE', intended);
    return next({ path: '/sixDigitAuthorization' });
  }

  if (isAllowedQueryRoute(to)) return next();
 
  const requiresAuth = !PUBLIC_PATHS.includes(to.path);
  if (!isLoggedIn && requiresAuth) {
    return next({ path: '/login', query: { dest: to.fullPath } });
  }
 
  // If logged in but not 2FA verified -> force six-digit
  if (isLoggedIn && !is2faVerified) {
    if (to.path === '/sixDigitAuthorization' || PUBLIC_PATHS.includes(to.path)) return next();
    // save intended route in module state
    store.commit('login/SET_INTENDED_ROUTE', to.fullPath);
    return next({ path: '/sixDigitAuthorization' });
  }
 
  // If at six-digit but not logged in -> send to login
  if (to.path === '/sixDigitAuthorization' && !isLoggedIn) {
    return next({ path: '/login' });
  }

  if (isBlockedDirectivesRoute(to)) {
    return next({ path: '/welcome' });
  }

  return next();
}

